import { API } from "@brg/api";
import axios from "axios";
import { matchPath } from "react-router-dom";
import { LinkTo } from "shared/constants/linkTo";
import { EndpointsServer } from "shared/constants/server";
import { getCommonDesignerTabsFilters, getDesignerTabsFilters, getSuperPuperTabsFilter } from "shared/hooks/useProfileTabs";


export const ssrGetInitData = async (props: any) => {
    const { req, res, next, definedApp, ...rest } = props || {}
    const host = req.get('host')
    const reqUrl = new URL(`${req.protocol}:${host}${req.url}`)
    const urlToMatch = definedApp.basePath ? reqUrl.pathname.replace(definedApp.basePath, '') : reqUrl.pathname
    const designerMatch: any = matchPath(urlToMatch, {path: LinkTo.designer, exact: true })
    const { id } = designerMatch?.params
    const designerUrl = id && `${EndpointsServer.geograffee}/api/Designer/Get?idDesigner=${id}`
    const designerResponse = id && await axios.get(designerUrl).catch((e) => {
        if (e.response.status === 404) {
            return {
                is404: true,
            }
        }
    });
    const designer = designerResponse?.data
    // const isTeacher = designer?.globalTypes?.includes('Employee');
    // const isSuperPuper = false
    // const isAgeyTomesh = false
    // const isMe = false
    // const superPuperFilter = getSuperPuperTabsFilter()
    // const commonFilter = getCommonDesignerTabsFilters({ isAgeyTomesh })
    // const designerTabs = getDesignerTabsFilters({commonFilter, id, isAgeyTomesh, isMe, isSuperPuper, isTeacher, superPuperFilter, tagId: ''})
    // const tabsItemsCountUrl = `${Endpoints.geograffee.production}/api/Designer/GetTabsItemsCount`
    // const responseAll = await Promise.all([
    //     //@ts-ignore
    //     ...designerTabs 
    //         ? [axios.post(tabsItemsCountUrl, { tabs: designerTabs })] 
    //         : [],
    //     // [запросы к карточкам если надо]
    // ])
    // const [designerTabsResponse] = responseAll

    // console.log('ssrGetInitData!!!', {designerUrl, designer});
    return {
        id,
        designer,
        // tabs: designerTabsResponse?.data?.tabs,
        tabs: [],
        designerRu: designer && API.toLang(designer, 'ru'),
        designerEn: designer && API.toLang(designer, 'ru'),
        definedApp,
        // notFound: designerResponse?.is404
    }
}import { API } from "@brg/api";
import axios from "axios";
import { matchPath } from "react-router-dom";
import { LinkTo } from "shared/constants/linkTo";
import { EndpointsServer } from "shared/constants/server";
import { getCommonDesignerTabsFilters, getDesignerTabsFilters, getSuperPuperTabsFilter } from "shared/hooks/useProfileTabs";


export const ssrGetInitData = async (props: any) => {
    const { req, res, next, definedApp, ...rest } = props || {}
    const host = req.get('host')
    const reqUrl = new URL(`${req.protocol}:${host}${req.url}`)
    const urlToMatch = definedApp.basePath ? reqUrl.pathname.replace(definedApp.basePath, '') : reqUrl.pathname
    const designerMatch: any = matchPath(urlToMatch, {path: LinkTo.designer, exact: true })
    const { id } = designerMatch?.params
    const designerUrl = id && `${EndpointsServer.geograffee}/api/Designer/Get?idDesigner=${id}`
    const designerResponse = id && await axios.get(designerUrl).catch((e) => {
        if (e.response.status === 404) {
            return {
                is404: true,
            }
        }
    });
    const designer = designerResponse?.data
    // const isTeacher = designer?.globalTypes?.includes('Employee');
    // const isSuperPuper = false
    // const isAgeyTomesh = false
    // const isMe = false
    // const superPuperFilter = getSuperPuperTabsFilter()
    // const commonFilter = getCommonDesignerTabsFilters({ isAgeyTomesh })
    // const designerTabs = getDesignerTabsFilters({commonFilter, id, isAgeyTomesh, isMe, isSuperPuper, isTeacher, superPuperFilter, tagId: ''})
    // const tabsItemsCountUrl = `${Endpoints.geograffee.production}/api/Designer/GetTabsItemsCount`
    // const responseAll = await Promise.all([
    //     //@ts-ignore
    //     ...designerTabs 
    //         ? [axios.post(tabsItemsCountUrl, { tabs: designerTabs })] 
    //         : [],
    //     // [запросы к карточкам если надо]
    // ])
    // const [designerTabsResponse] = responseAll

    // console.log('ssrGetInitData!!!', {designerUrl, designer});
    return {
        id,
        designer,
        // tabs: designerTabsResponse?.data?.tabs,
        tabs: [],
        designerRu: designer && API.toLang(designer, 'ru'),
        designerEn: designer && API.toLang(designer, 'ru'),
        definedApp,
        // notFound: designerResponse?.is404
    }
}